export default __webpack_public_path__ + "static/media/memories.3515da33.png";